import { ApolloError } from '@apollo/client'
import { useMemo } from 'react'

import { usePractitionerSettings } from './usePractitionerSettings'

export type UseShowDispensary = [
  showDispensary: boolean | undefined,
  metadata: { loading: boolean; error: ApolloError | Error | undefined; called: boolean },
]

export const useShowDispensary = (): UseShowDispensary => {
  const [settings, { loading, error, called }] = usePractitionerSettings()

  const showDispensary = useMemo(() => {
    return !settings?.practitioner.optedOutOfDispensary
  }, [settings])

  return [showDispensary, { loading, error, called }]
}

export default useShowDispensary
